import { render } from "./Footer.vue?vue&type=template&id=45837b2a&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=45837b2a&lang=scss&scoped=true"

import exportComponent from "E:\\Projects\\leeno\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45837b2a"]])

export default __exports__